import { axiosInstance } from "./api";


/**
 * Get property for a given project.
 */
export const fetchRunners = async (projectId) => {
  const response = await axiosInstance.get(
    `/runners/get/${projectId}`
  );
  return response.data ?? null;
};

/**
 * Update result.
 */
export const putResult = async (resultId, payload) => {
  const response = await axiosInstance.put(
    `/results/${resultId}`, payload
  );
  return response.data ?? null;
};

/**
 * Delete result.
 */
export const deleteRunner = async (runnerId) => {
  const response = await axiosInstance.delete(
    `/runner2/${runnerId}`
  );
  return response.data ?? null;
};
